module.exports = __webpack_public_path__ + "media/images/career_camp/2023/count_2-019789c4784aa77f47f6901154bd5fbd.svg";